// External
import { Directive } from '@angular/core';

// Internal

@Directive({
    selector: 'card-header, [card-header]',
    exportAs: 'cardHeader',
    host: {
        '[class.card-header]': 'true'
    }
})
export class CardHeaderDirective {

    constructor() { }

}
